var _style, _polygon, _polygon2, _polygon3, _polygon4, _circle, _polygon5, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#666666;}\r\n\t.st1{fill:#F2F2F2;}\r\n\t.st2{fill:#0066CC;}\r\n\t.st3{fill:#0099FF;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:none;stroke:#666666;stroke-width:0.7;stroke-miterlimit:10;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.8,18.8 1.2,18.8 1.2,1.2 14,1.2 18.8,6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "13.6,1.9 1.9,1.9 1.9,18.1 18.1,18.1 18.1,6.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "12.5,13.4 4.5,13.4 8.5,7.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "15.5,13.6 9.5,13.6 12.5,9.6 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 14.5,
    cy: 8.5,
    r: 0.9
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "13.6,1.9 13.6,6.4 18.1,6.4 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "18.6,6.4 13.6,6.4 13.6,1.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b9146320c0cb48d6a99f357abad458a7.svg";
export { ForwardRef as ReactComponent };